
ADILF.define('adilf/apps/social/promo-modules/collection-promo-base/views/twitter-content-view',['require','exports','module','inherits','view/composite-view','streamhub-sdk/content/views/content-header-view','streamhub-sdk/content/views/content-body-view','streamhub-sdk/content/views/content-footer-view','streamhub-sdk/content/views/tiled-attachment-list-view','streamhub-sdk/content/views/block-attachment-list-view','streamhub-sdk/content/content-header-view-factory','streamhub-sdk/content/views/twitter-content-view'],function (require, exports, module) {'use strict';

var inherits = require('inherits');
var CompositeView = require('view/composite-view');
var ContentHeaderView = require('streamhub-sdk/content/views/content-header-view');
var ContentBodyView = require('streamhub-sdk/content/views/content-body-view');
var ContentFooterView = require('streamhub-sdk/content/views/content-footer-view');
var TiledAttachmentListView = require('streamhub-sdk/content/views/tiled-attachment-list-view');
var BlockAttachmentListView = require('streamhub-sdk/content/views/block-attachment-list-view');
var ContentHeaderViewFactory = require('streamhub-sdk/content/content-header-view-factory');
var BaseTwitterContentView = require('streamhub-sdk/content/views/twitter-content-view');

var TwitterContentView = function(opts) {
    opts = opts || {};
    BaseTwitterContentView.apply(this, arguments);
};
inherits(TwitterContentView, BaseTwitterContentView);

TwitterContentView.prototype._addHeaderView = function(opts) {
    this._headerView = opts.headerView || this._headerViewFactory.createHeaderView(opts.content);
    this.add(this._headerView, { render: false });
};

TwitterContentView.prototype._hasPhoto = function() {
    return (this.content.attachments.length && this.content.attachments[0].type === "photo");
};

TwitterContentView.prototype._addInitialChildViews = function (opts) {

    if(!this._hasPhoto()) {
        this._addHeaderView(opts);
    }

    this._bodyView = opts.bodyView || new ContentBodyView(opts);
    this.add(this._bodyView, { render: false });

    this._footerView = opts.footerView || new ContentFooterView(opts);
    this.add(this._footerView, { render: false });

    // if there's an image, put headerView here...
    if(this._hasPhoto()) {
        this._addHeaderView(opts);
    }

    this._thumbnailAttachmentsView = new TiledAttachmentListView(opts);
    this._blockAttachmentsView = new BlockAttachmentListView(opts);
    this._attachmentsView = opts.attachmentsView || new CompositeView(this._thumbnailAttachmentsView, this._blockAttachmentsView);
    this.add(this._attachmentsView, { render: false });

};

module.exports = TwitterContentView;
});
